import tw from 'twin.macro';
import {
  ContextualCategory,
  ContextualTraceabilityType,
} from '@insights_module/types/Traceability';
import { ContextualCategoryLabel } from '@insights_module/components/episode_details_screen/ContextualCategoryLabel';

const Container = tw.div`flex items-end justify-start flex-wrap gap-2 my-2`;

export const TranscriptContextualLabels = ({
  contextual,
}: {
  contextual: Omit<ContextualTraceabilityType, 'start_time' | 'end_time'> | undefined;
}) => {
  if (!contextual) return null;

  return (
    <Container>
      {contextual?.categories?.map((category: ContextualCategory) => (
        <ContextualCategoryLabel key={category.id} category={category} />
      ))}
    </Container>
  );
};
